import {Race} from "../race";
import {EventItem} from "../event-item";
import {PaymentStatus} from "../wspay/wspay-confirmation";
import {Competitor} from "../competitor";
import {RegistrationStatus} from "./registration-status";
import {PaymentType} from "./payment-type";
import {PaymentOrder} from "./payment-order";
import {AmountStatus} from "./amount-status";

export class RaceRegistration {
  id?: number;
  raceId?: number;
  userId?: number;
  receiptEmail?: string;
  registrationStatus?: RegistrationStatus;
  paymentTypes?: PaymentType[];
  totalAmount?: number;
  totalAmountWithDiscount?: number;
  created?: Date;
  paymentTimestamp?: Date;
  endDateForPayment?: Date;
  currencyCode?: string;
  wsPayFormUrl?: string;
  wsPayCartId?: string;
  wsPayApprovalCode?: string;
  wsPayTransactionId?: string;
  paymentStatus?: PaymentStatus;
  competitors?: Competitor[];
  teamRegistration?: boolean;
  order?: PaymentOrder;
  amountStatus?: AmountStatus;
  race?: Race;
  events?: EventItem;

  static getTypeOfRegistration(raceRegistration?: RaceRegistration): TypeOfRegistration {
    var typeOfRegistration: TypeOfRegistration;
    if (raceRegistration?.teamRegistration) {
      typeOfRegistration = TypeOfRegistration.TEAM;
    } else if ((raceRegistration?.competitors?.length ?? 0) > 1) {
      typeOfRegistration = TypeOfRegistration.GROUP;
    } else {
      typeOfRegistration = TypeOfRegistration.SINGLE;
    }
    return typeOfRegistration;
  }

  static getAmountStatus(registration?: RaceRegistration): AmountStatus {
    const amountStatus: AmountStatus = registration?.amountStatus ?? ((registration?.paymentStatus === PaymentStatus.SUCCESS || registration?.registrationStatus === RegistrationStatus.CONFIRMED) ?
        AmountStatus.EXACT : AmountStatus.NOT_PAID);
    return amountStatus;
  }
}

export enum TypeOfRegistration {
  SINGLE = 0, GROUP = 1, TEAM = 2
}
